@if (!isRendering) {
  <div [ngClass]="rowIndex | fdgLegendCss: dataAngles">
    @for (angle of lineChartAngles; track angle) {
      <span class="legend-angle">
        {{angle}}°
      </span>
    }
  </div>
  <canvas #chartFDG width="100" height="135"></canvas>
}
